import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { IPalletSelectorState, PalletSelectorReducer } from "./PalletSelectorReducer";

const PalletSelectorRootReducer = combineReducers({
	PalletSelector: PalletSelectorReducer,
});

export type PalletSelectorRootState = ReturnType<typeof PalletSelectorRootReducer>;


export interface DispatchAction extends Action {
	payload: Partial<IPalletSelectorState>;
}

const middleware = thunk as ThunkMiddleware<PalletSelectorRootState, DispatchAction>;

export const palletSelectorStore = configureStore({
	reducer: PalletSelectorRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(middleware),
});
